/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/*global Slick */

expocadfx.DeletedBoothList = function( div) {
	'use strict';
	var comparer = expocadfx.comparer;
    var FxEvent = expocadfx.fxevent;  
    var Grid = Slick.Grid;
    var txt = expocadfx.txt;
    var dataview = new Slick.Data.DataView( {inlineFilters: false});
    
    var gridBooths = null;    //  the grid component
    
    var doc = document;
    var divBooths = div;
    var booths = null;
	var searchString = "";
	var searchField = doc.getElementById( "cSrch");
    
    var columns = [
            {id:"boothLabel", name:txt.BOOTH_NUMBER, field:"BoothNumber", cssClass:"cell-text"},
            {id: "boothArea", name: txt.AREA, field: "Area" }
        ];
    var options = {
        enableCellNavigation: true,
        enableColumnReorder: false,
        forceFitColumns: true,
        rowHeight: 24
    };
	
    function updateFilter() {
        dataview.setFilterArgs( { searchString: searchString});
        dataview.refresh();
        gridBooths.invalidate();
    }
	
    function basicFilter( item, args) {
        if ( args.searchString !== "" && 
            ( item.BoothNumber.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1 &&
				item.Area.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1)) {
            return false;
        }
        else {
            return true;
        }
    }
	
    function gridClickHandler( evt) {
        var cell = gridBooths.getCellFromEvent( evt);
        var number = dataview.getItem( cell.row).BoothNumber;
        doc.dispatchEvent( new FxEvent( "Deleted_Booth_Click", { "boothNumber":number }));
    }

    function createBoothGrid() { 
        gridBooths = new Grid( divBooths, dataview, columns, options);
        gridBooths.setSelectionModel(new Slick.RowSelectionModel());
          
        gridBooths.onClick.subscribe( function( evt) {
            gridClickHandler( evt);
        });
    }
	
	function setBooths( value) {
		booths = value;
		var i;
		var len = booths.length;
		for( i = 0; i < len; i++) {
			booths[i].id = i;
		}

		dataview.beginUpdate();
		dataview.setItems( booths);
		dataview.setFilterArgs( { searchString: searchString});
		dataview.setFilter( basicFilter);
		dataview.endUpdate();
		dataview.sort( comparer( "BoothNumber"), true);

		createBoothGrid();
	}
    

    if( searchField !== null) {
        searchField.addEventListener( "input", function () {
            searchString = searchField.value;
            updateFilter();
        });
    }
    
    
    return {
        setBooths: setBooths
    };
};